import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Events } from 'src/app/shared/models/event.model';
import { PaginationArgs } from 'src/app/shared/models/pagination.args.model';
import { ToastService } from 'src/app/shared/services/toast.service';
import { HomeService } from '../../services/home.service';

@Component({
  selector: 'app-all-events-home',
  templateUrl: './all-events-home.component.html',
  styleUrls: ['./all-events-home.component.scss']
})
export class AllEventsHomeComponent implements OnInit {
  filterForm: FormGroup;
  events: Events[];
  orderBy = { order_by: 'createdAt', order_by_sorting: 'DESC' }
  paginationArgs: PaginationArgs = { pageNumber: 1, pageSize: 6 };
  eventCount: number;
  public minDate = {
    year: 1970,
    month: 1,
    day: 1
  };

  public maxDate = {
    year: 2050,
    month: 12,
    day: 31
  };
  loadingEvents: boolean;

  constructor(
    private homeService: HomeService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private toastService: ToastService) { }

  ngOnInit(): void {
    this.initFilter();
    this.getFiltredEvents(this.paginationArgs);
  }

  initFilter() {
    this.filterForm = this.formBuilder.group({
      filter: this.formBuilder.group({
        search_value: new FormControl(''),
        startingDate: new FormControl(''),
        endDate: new FormControl(''),
      }),
      sorting: this.formBuilder.group({
        order_by: 'createdAt',
        order_by_sorting: 'DESC'
      })
    })
  }

  getFiltredEvents(paginationArgs) {
    this.loadingEvents = true
    let formBody = Object.assign({}, this.filterForm.value['filter'], {
      startingDate: this.filterForm.get('filter').get('startingDate').value ? this.datePipe.transform(new Date(this.filterForm.get('filter').get('startingDate').value.year, this.filterForm.get('filter').get('startingDate').value.month - 1, this.filterForm.get('filter').get('startingDate').value.day), 'yyyy-MM-dd') : '',
      endDate: this.filterForm.get('filter').get('endDate').value ? this.datePipe.transform(new Date(this.filterForm.get('filter').get('endDate').value.year, this.filterForm.get('filter').get('endDate').value.month - 1, this.filterForm.get('filter').get('endDate').value.day), 'yyyy-MM-dd') : '',
    });

    this.homeService.eventsFilter(paginationArgs, formBody, this.filterForm.value['sorting']).subscribe(res => {
      this.eventCount = res.numberMaxRequest;
      this.events = res.Data.map(item => {
        return Object.assign({}, item, {
          createdAt: new Date(item.createdAt).getTime() - new Date().getTimezoneOffset() * 60 * 1000,
        })
      });

      this.loadingEvents = false
    })
  }

  changePage(event) {
    this.paginationArgs.pageNumber = event;
    this.getFiltredEvents(this.paginationArgs)
  }

  focusedField(event) {
    if (event.type == 'focus') {
      event.target.closest('.label-floating').classList.add('is-focused');
    } else {
      event.target.closest('.label-floating').classList.remove('is-focused');
    }
  }

  filterEvent() {
    this.paginationArgs.pageNumber = 1;
    this.getFiltredEvents(this.paginationArgs);
  }

  search() {
    this.paginationArgs.pageNumber = 1
    this.getFiltredEvents(this.paginationArgs);
  }

  cancel() {
    this.paginationArgs.pageNumber = 1;
    (<FormGroup>this.filterForm.controls['filter']).patchValue(
      {
        search_value: '',
        startingDate: '',
        endDate: '',
      }
    );

    this.getFiltredEvents(this.paginationArgs);
  }
}
